module.exports = __webpack_public_path__ + "img/iphone-3.046f1722.svg";